import React, { useState } from "react";

export const themes = {
  light: {
    foreground: "#fafafa",
    background: "#ffffff",
    lightFont: "#716E8B",
    primaryFont: "#5F5D77",
    headerFont: "#442ED0",
    subheaderFont: "#5F5D77",
    secondaryFont: "#393649",
    purpleFont: "#442ECF",
    darkPurple: "#0C024D",
    buttonFont: "#442ECF",
    lightPurple: "#9490B1",
    greenFont: "#36D763",
    redFont: "#EA2664",
    darkFont: "#22202D",
    ashFont: "#7D7B96",
  },
  dark: {
    foreground: "#2a2a2a",
    background: "#000000",
    lightFont: "#B4B0D1",
    primaryFont: "#ffffff",
    headerFont: "#442ED0",
    subheaderFont: "#5F5D77",
    buttonFont: "#ffffff",
    secondaryFont: "#F5F4FA",
    purpleFont: "#442ECF",
    darkPurple: "#442ECF",
    lightPurple: "#9490B1",
    greenFont: "#36D763",
    redFont: "#EA2664",
    darkFont: "#ffffff",
    ashFont: "#7D7B96",
  },
};

export const themeContext = React.createContext();

let defaultTheme;

if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
  // defaultTheme = true;
  defaultTheme = false;
} else {
  defaultTheme = false;
}

export const ThemeProvider = (props) => {
  const [isDark, setIsDark] = useState(defaultTheme);

  let theme;
  if (isDark) {
    theme = themes.dark;
  } else {
    theme = themes.light;
  }

  const toggleTheme = () => setIsDark(!isDark);

  return (
    <themeContext.Provider
      value={{
        theme,
        toggleTheme,
        isDark,
      }}
    >
      {props.children}
    </themeContext.Provider>
  );
};
